import type { WalkthroughConfig } from "../types";

export const communicationsWalkthrough: WalkthroughConfig = {
  id: "page-communications",
  title: "Communications Hub",
  description: "Learn to create campaigns, automations, and member journeys.",
  type: "page",
  pageRoute: "/communications",
  duration: "1 min",
  category: "pages",
  icon: "Mail",
  steps: [
    {
      id: "intro",
      title: "Communications Center",
      description:
        "Send targeted email campaigns, build automated journeys, and manage all your member communications from one unified hub.",
      placement: "center",
      animation: "fade",
      icon: "Mail",
    },
    {
      id: "campaigns",
      title: "Email Campaigns",
      description:
        "Create beautiful, responsive emails with the drag-and-drop builder. Segment your audience, schedule sends, and track opens, clicks, and conversions.",
      placement: "center",
      animation: "slide-up",
      icon: "Mail",
    },
    {
      id: "automations",
      title: "Automated Journeys",
      description:
        "Set up welcome sequences, renewal reminders, re-engagement flows, and event follow-ups that run automatically based on member behavior.",
      placement: "center",
      animation: "fade",
      icon: "Route",
    },
    {
      id: "analytics",
      title: "Performance Analytics",
      description:
        "Track delivery rates, engagement trends, and campaign ROI. Identify your most effective content and optimize over time.",
      placement: "center",
      animation: "scale",
      icon: "TrendingUp",
      nextLabel: "Got it! ✓",
    },
  ],
};
